import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React from "react";

const ScarceSkills = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Mobile Card Component for better mobile experience
  const ScarceSkillCard = ({ rank, occupationName, specialization }) => (
    <Card
      sx={{
        mb: 2,
        boxShadow: 3,
        "&:hover": {
          boxShadow: 6,
          transform: "translateY(-2px)",
          transition: "all 0.3s ease-in-out"
        }
      }}
    >
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Chip
            label={`Rank #${rank}`}
            color="primary"
            size="small"
            sx={{ fontWeight: "bold" }}
          />
        </Box>

        <Typography
          variant="h6"
          color="primary"
          gutterBottom
          sx={{ fontWeight: "bold" }}
        >
          {occupationName}
        </Typography>

        {specialization && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: "italic" }}
          >
            <strong>Specializations:</strong> {specialization}
          </Typography>
        )}
      </CardContent>
    </Card>
  );

  return (
    <Stack spacing={2} sx={{ width: "fit-content" }}>
      <Typography
        fontSize={20}
        fontWeight="bolder"
        sx={{ color: "primary.main", textTransform: "uppercase" }}
      >
        CAREER AWARNESS VOLUNTEER
      </Typography>
      <Typography textAlign="justify">
        Pay it forward and volunteer your time! We are looking for passionate
        individuals who want to make a real difference to young people. We are
        looking for volunteers to help us with disseminating career awareness
        information. We are calling upon our Alumni to volunteer their time and
        give career awareness talks at schools, youth centres, churches and
        communities around you. If you wish to pledge your support and
        volunteer, please send an email to{" "}
        <a href={`mailto:Unathi.Nkosiyane@fasset.org.za`}>
          Unathi.Nkosiyane@fasset.org.za
        </a>{" "}
      </Typography>
      <Typography
        fontSize={20}
        fontWeight="bolder"
        sx={{ color: "primary.main", textTransform: "uppercase" }}
      >
        Scarce Skills
      </Typography>

      <Typography textAlign="justify">
        Scarce skills refers to a shortage of people with the required
        attributes to fill positions available in the labour market. The
        attributes that employers are seeking when they try to fill positions in
        their organisations are specifically important. These may be
        qualifications, specific skills and experience, a specific race or
        gender or a combination of these attributes. Scarce skills are normally
        expressed in terms of the occupations for which there are not enough
        candidates available. Scarce skills in the financial services sector are
        mainly in the professional and technician and associated professional
        occupations. Although these occupational categories are experiencing
        above average growth, the shortages are often related to very special
        skills sought by employers. The lack of qualified black people,
        especially in the higher level occupations and professional
        designations, is considered a serious problem. The Sector Skills Plan of
        FASSET, 2016 - 2021 indicated that shortages of finance and accounting
        services skills exist at all levels – from clerical to technician, and
        administrative to professional, and managerial.
      </Typography>
      <Divider />
      <Typography
        fontSize={20}
        fontWeight="bolder"
        sx={{ color: "primary.main", textTransform: "uppercase" }}
      >
        FASSET SECTORAL PRIORITY OCCUPATIONS
      </Typography>
      <Typography textAlign="justify">
        Sectoral priority occupations refers to a shortage of people with the
        required attributes to fill positions available in the labour market.
        The attributes that employers are seeking when they try to fill
        positions in their organisations are specifically important. These may
        be qualifications, specific skills and experience, a specific race or
        gender, or a combination of these attributes. Sectoral Priority
        Occupations are normally in terms of the occupations for which there are
        not enough candidates available. Sectoral Priority Occupations in the
        financial services sector are mainly in professional and technician and
        associated professional occupations. Although these occupational
        categories are experiencing above average growth, the shortages are
        often related to very special skills sought by employers. The lack of
        qualified black people, especially in the higher level occupations and
        professional designations, is considered a serious problem.
      </Typography>
      {isMobile ? (
        // Mobile View - Card Layout
        <Box>
          {scarceSkills.map((skill, index) => (
            <ScarceSkillCard
              key={index}
              rank={index + 1}
              occupationName={skill.occupationName}
              specialization={skill.specialization}
            />
          ))}
        </Box>
      ) : (
        // Desktop View - Enhanced Table
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            boxShadow: 4,
            overflow: "hidden"
          }}
        >
          <Table sx={{ minWidth: 650 }} aria-label="scarce skills table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    backgroundColor: "primary.main",
                    fontSize: "1rem",
                    py: 2
                  }}
                >
                  RANK
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    backgroundColor: "primary.main",
                    fontSize: "1rem",
                    py: 2,
                    minWidth: 200
                  }}
                >
                  OCCUPATION NAME
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    backgroundColor: "primary.main",
                    fontSize: "1rem",
                    py: 2,
                    minWidth: 300
                  }}
                >
                  SPECIALIZATION / ALTERNATIVE TITLE
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {scarceSkills.map((row, i) => (
                <TableRow
                  key={i}
                  sx={{
                    "&:nth-of-type(odd)": {
                      backgroundColor: "rgba(0, 0, 0, 0.02)"
                    },
                    "&:hover": {
                      backgroundColor: "rgba(25, 118, 210, 0.04)",
                      transition: "background-color 0.3s ease"
                    }
                  }}
                >
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                      color: "primary.main",
                      py: 2
                    }}
                  >
                    {i + 1}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    sx={{
                      fontWeight: "bold",
                      color: "text.primary",
                      py: 2,
                      fontSize: "0.95rem"
                    }}
                  >
                    {row.occupationName}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    sx={{
                      py: 2,
                      fontSize: "0.9rem",
                      fontStyle: row.specialization ? "normal" : "italic",
                      color: row.specialization
                        ? "text.primary"
                        : "text.secondary"
                    }}
                  >
                    {row.specialization || "No specific specializations listed"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Stack>
  );
};

const scarceSkills = [
  {
    occupationName: "Financial Accountant",
    specialization:
      "Business Group Accountant, Company Accountant, Corporate Accountant"
  },
  {
    occupationName: "Tax Professional",
    specialization: "Tax Analyst, Tax Consultant, Tax Auditor"
  },
  {
    occupationName: "Finance Manager",
    specialization:
      "Chief Accountant, Finance Director, Finance Controller, Chief Financial Officer"
  },
  {
    occupationName: "Accounting Technician",
    specialization: ""
  },
  {
    occupationName: "Tax Technician",
    specialization: ""
  },
  {
    occupationName: "Management Accountant",
    specialization: "Project Accountant, Cost Accountant, Budget Accountant"
  },
  {
    occupationName: "Human Resource Manager",
    specialization: "Employee Relations Manager"
  },
  {
    occupationName: "External Auditor",
    specialization:
      "Forensic Auditor / Investigator, Project Auditor, Audit and Assurance Manager"
  },
  {
    occupationName: "Business Analyst",
    specialization: ""
  },
  {
    occupationName: "Learning and Development Manager (Training Manager)",
    specialization:
      "Business Training Manager, Education Training and Skills Development Manager, Quality Training Manager, Training & Development Manager, Assessments Manager"
  }
];

export default ScarceSkills;
